module.exports = __webpack_public_path__ + "static/assets/6797bfe614ccb22ae04e5aa618d7f483.png";